import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { NoRxSelectionColumn } from './NoRxSelectionColumn.js';
import { useFetchCLByPrescription } from '../../../../hooks/use-fetch-cl-by-prescription.js';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';

const NoRxSelectionColumnContainer = (props)=>{
    const { eyeSideId  } = props;
    const { state , selectors  } = useCLEcommContext();
    const { isValid , isEnabled  } = state.configurator[eyeSideId];
    const { prescription  } = state.configurations[eyeSideId];
    const hasNonRecoverableError = selectors.hasNonRecoverableError(state);
    const fetchCLByPrescription = useFetchCLByPrescription({
        eyeSide: eyeSideId
    });
    React.useEffect(()=>{
        if (!isValid || !isEnabled || hasNonRecoverableError) {
            return;
        }
        // Fetch should be immediately called on pageload, because "NoRx" Lenses
        // already have a prescription filled in by default
        fetchCLByPrescription(prescription);
    }, [
        fetchCLByPrescription,
        prescription,
        isEnabled,
        isValid,
        hasNonRecoverableError
    ]);
    return /*#__PURE__*/ React.createElement(NoRxSelectionColumn, swcHelpers.extends({}, props));
};

export { NoRxSelectionColumnContainer };
//# sourceMappingURL=NoRxSelectionColumnContainer.js.map
